import { useParams } from "react-router-dom";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { ConfigElement } from "types/generated";
import useIntentProjectConfigDelete from "shared/IntentProject/useIntentProjectConfigDelete";
import useIntentProject from "shared/IntentProject/useIntentProject";
import useCanUpdateIntentProjectConfig from "shared/IntentProject/access/useCanUpdateIntentProjectConfig";
import useCanDeleteIntentProjectConfig from "shared/IntentProject/access/useCanDeleteIntentProjectConfig";

import { showIntentProjectEnvironmentMountedFileFormDrawer } from "../../MountedFileFormDrawer";

const IntentProjectEnvironmentMountedFilesTableRowActionsCell = ({
  item: variable,
  ...cellProps
}: TableSimpleCellProps<ConfigElement>) => {
  const { intentProjectId } = useParams<{ intentProjectId: string }>();
  const { intentProject } = useIntentProject();
  const { deleteConfigFromIntentProject, loading } = useIntentProjectConfigDelete();

  const canUpdateConfig = useCanUpdateIntentProjectConfig()(intentProject?.space.id);
  const canDeleteConfig = useCanDeleteIntentProjectConfig()(intentProject?.space.id);

  const handleDelete = () => {
    if (!intentProjectId) return;
    deleteConfigFromIntentProject(intentProjectId, variable.id);
  };

  const handleEdit = () => {
    if (!intentProjectId) return;
    showIntentProjectEnvironmentMountedFileFormDrawer({ intentProjectId, file: variable });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Variable actions">
        <DropdownMenuItem
          onAction={handleEdit}
          isDisabled={!canUpdateConfig.result}
          tooltip={canUpdateConfig.message}
          tooltipPlacement="left"
        >
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          onAction={handleDelete}
          danger
          isDisabled={loading || !canDeleteConfig.result}
          tooltip={canDeleteConfig.message}
          tooltipPlacement="left"
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default IntentProjectEnvironmentMountedFilesTableRowActionsCell;
